import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NgxSpinnerService } from "ngx-spinner";
import { Subject } from "rxjs";
import { CardView } from "src/app/interfaces/cardview";
import { DialogService } from "src/app/services/dialog.service";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import introJs from "intro.js/intro.js";
import { TutorialServices } from "src/app/services/tutorial.services";

@Component({
    selector: "app-setup-integration-view",
    templateUrl: "./setup-integration-view.component.html",
    styleUrls: ["./setup-integration-view.component.scss"],
    standalone: false
})
export class SetupIntegrationViewComponent implements OnInit {
  selectedOptions = [];
  selectedOption;
  loadingDataUsers: boolean;
  integrationRow: any;
  condition: string;
  conditionContract: string;
  conditionServices: string;
  conditionLgi: string;
  conditionError: string;
  integrationName: string;
  introJS = introJs();

  eventsSubject: Subject<string> = new Subject<string>();
  parentRow: CardView = {};
  parentRowContract: any;
  parentRowServices: any;
  parentRowLgi: any;
  parentRowCid: any;
  parentRowError: any;
  typeIntegration: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData,
    public dialogRef: MatDialogRef<any>,
    public dialogService: DialogService,
    public tutorialServices:TutorialServices
  ) {}

  ngOnInit(): void {
    this.integrationRow = this.dialogData;
    this.typeIntegration =  this.dialogData.typeIntegration;
    
    this.condition =
      "IDCONF = " +
      this.integrationRow.idConf +
      " AND SEQUENCE = " +
      this.integrationRow.sequence;

    this.conditionContract =
      "CODECONTRACT = " +
      this.integrationRow.codeContract +
      " AND CODECOMPANY = " +
      this.integrationRow.codeCompany +
      "AND CODEMKTP = " +
      this.integrationRow.codeMktp;

    this.conditionServices = "CODEMKTP = " + this.integrationRow.codeMktp;

    this.conditionLgi = "IDCONF = " + this.integrationRow.idConf;

    this.integrationName = this.integrationRow.name;

    this.conditionError =
      "IDCONF = " +
      this.integrationRow.idConf +
      " AND CODECOMPANY = " +
      this.integrationRow.codeCompany +
      "AND CODEMKTP = " +
      this.integrationRow.codeMktp;

    this.parentRowContract = {};
    this.parentRowContract.linha = {
      CODECOMPANY: this.integrationRow.codeCompany,
      CODECONTRACT: this.integrationRow.codeContract,
      CODEMKTP: this.integrationRow.codeMktp,
    };

    this.parentRowServices = {};
    this.parentRowServices.linha = {
      CODEMKTP: this.integrationRow.codeMktp,
    };

    this.parentRowLgi = {};
    this.parentRowLgi.linha = {
      IDCONF: this.integrationRow.codeMktp,
      CODECOMPANY: this.integrationRow.codeCompany,
    };

    this.parentRowCid = {};
    this.parentRowCid.linha = {
      IDCONF: this.integrationRow.idConf,
      SEQUENCE: this.integrationRow.sequence,
    };

    this.parentRowError = {};
    this.parentRowError.linha = {
      IDCONF: this.integrationRow.idConf,
      CODEMKTP: this.integrationRow.codeMktp,
      CODECOMPANY: this.integrationRow.codeCompany,
    };
  }

  showTutorial() {
    this.tutorialServices.loadByPK("3").then((result) => {
      var resultsTutorial = this.tutorialServices.resultMktpTutorial;

      if(resultsTutorial.length > 0){
        introJs()
        .setOptions(resultsTutorial[0].tutorial).start();
      }

   });    
    //introJs().setOption("nextLabel", "Avançar");
   /* introJs()
      .setOptions({
        dontShowAgain: "true",
        dontShowAgainLabel: "Não exibir novamente",
        nextLabel: "Avançar",
        prevLabel: "Voltar",
        doneLabel: "Finalizar",
        steps: [
          {
            title: "Detalhes da Integração",
            intro:
              "Nas abas acima você pode configurar todos os parâmetros da sua integração.",
          },
          {
            element:
              document.getElementsByClassName("mat-tab-labels")[0]
                .childNodes[0],
            intro:
              "Na aba de configurações é onde você define as principais informações como por exemplo a URL que será chamada.",
          },
          {
            element:
              document.getElementsByClassName("mat-tab-labels")[0]
                .childNodes[1],
            intro:
              "Na aba de DE-PARA, você informa a TAG que será lida (FROMDATA), o campo que será enviado essa informação (TODATA), a expressão e outras configurações. Utilizada para configurar a estrutura de envio / leitura dinamica dos elementos da integração.",
          },
          {
            element:
              document.getElementsByClassName("mat-tab-labels")[0]
                .childNodes[2],
            intro:
              "Na aba de Preferências do Contrato, você consegue cadastrar uma integração a um determinado contrato ou utilizar alguma integração existente que você tenha acesso pelo contrato.",
          },
          {
            element:
              document.getElementsByClassName("mat-tab-labels")[0]
                .childNodes[3],
            intro:
              "Na aba de URLS, você pode cadastrar as URLs que serão utilizadas no marketplace.",
          },
          {
            element:
              document.getElementsByClassName("mat-tab-labels")[0]
                .childNodes[4],
            intro:
              "Na aba de Serviços, você pode cadastrar serviços que vão compor as chamadas para URL, esses serviços serão utilizados na aba de detalhes da integração.",
          },
          {
            element:
              document.getElementsByClassName("mat-tab-labels")[0]
                .childNodes[5],
            intro:
              "Na aba de retorno da integração, você pode acompanhar em tempo real a execução das suas integrações para essa configuração.",
          },
          {
            element:
              document.getElementsByClassName("mat-tab-labels")[0]
                .childNodes[6],
            intro:
              "Na aba de erros da integração, você pode conferir o retorno dos erros para sua integração.",
          },
        ],
      })
      .start();*/
  }

  ngAfterViewInit() {
    this.showTutorial();
  }
  onNgModelChange($event) {
    this.selectedOption = $event;
  }

  finalizar(event: Event) {
    this.dialogRef.close(this.selectedOption);
  }
}
